// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"0e04a466","755":"f864caa6","787":"852661f1"}[chunkId] + ".chunk.js";
};